<mat-dialog-content class="dialog-content">
  <h2 mat-dialog-title>Relatórios</h2>
  <h2 mat-dialog-title></h2>
  <table mat-table [dataSource]="data.files" class="styled-table compact">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="header-cell left">
        Nome
      </th>
      <td mat-cell *matCellDef="let f" class="name-cell">
        {{ f.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef class="header-cell left">
        Tipo
      </th>
      <td mat-cell *matCellDef="let f" class="type-cell">
        {{ f.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="header-cell right">
        Ações
      </th>
      <td mat-cell *matCellDef="let f" class="actions-cell">
        <button class="icon-btn" aria-label="Visualizar" (click)="onPreview(f)">
          <mat-icon>visibility</mat-icon>
        </button>
        <!-- @if(f.type !== 'DRAFT') {
          <button class="icon-btn" aria-label="Baixar" (click)="onDownload(f)">
            <mat-icon>download</mat-icon>
          </button>
        } -->
        <span class="loading" *ngIf="previewing[f.path] || downloading[f.path]">
          <mat-progress-spinner mode="indeterminate" [diameter]="18"></mat-progress-spinner>
        </span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['name','type','actions',]" class="header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name','type','actions']" class="data-row"></tr>
  </table>
  <mat-dialog-actions align="end">
    <button mat-button class="button outline" (click)="close()"> Fechar </button>
  </mat-dialog-actions>
</mat-dialog-content>
